module.exports = __webpack_public_path__ + "static/rp-0b73795743129bc8ab7f930d0ab213b5.png";